import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { InfoV2Icon } from '@change/ds-icons';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

type InfoOtherSourceParams = {
	signaturePercent: number;
};

export const InfoOtherSource: React.FC<InfoOtherSourceParams> = ({ signaturePercent }) => {
	return (
		<div className="mb-6 flex flex-row items-center gap-1">
			<InfoV2Icon size={20} />
			<Text className="text-size-body">
				<TranslateHtml
					value="corgi.petition.starter_dashboard.petition_insights.signature_sources.info_other_source"
					replacements={{ numPercent: signaturePercent }}
				/>
			</Text>
		</div>
	);
};
